import { NextSeo } from "next-seo";
import HorseRacingHeader from "@/components/horseRacing/header/HorseRacingHeader";
import TermList from "@/components/horseRacing/termList";
import { RACING_BETTING_TERMS_PAGE_VIEWED } from "@/constants/amplitude";
import allTerms from "@/constants/hr-terminology.json";
import { SEO } from "@/constants/seo";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import useOnce from "@/utils/hooks/useOnce";
import styles from "./container.module.scss";

interface HorseBettingTermsContainerProps {
  title: string;
  description: string;
}

const Container = ({ title, description }: HorseBettingTermsContainerProps) => {
  const { logAmplitudeEvent } = useAmplitude();
  useOnce(() => {
    logAmplitudeEvent(RACING_BETTING_TERMS_PAGE_VIEWED, {});
  });
  return (
    <div className={styles.container}>
      <NextSeo
        description={description}
        title={title}
        canonical={SEO.HR_BETTING_TERMS_URL}
      />
      <div className={styles.offset}>
        <HorseRacingHeader title="Horse Racing Basic Terms" />
      </div>
      <TermList startingTerms={allTerms.terminology} />
    </div>
  );
};

export default Container;
